var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';
import { styled } from '@mui/system';
import { Container, ContainerBackgroundVariants, ContainerDisplays, ContainerFlexAlignItems, ContainerFlexDirections, ContainerFlexGaps, ContainerFlexJustifyContents, ContainerPaddings, ContainerWidths } from '../../../../templates/container';
import { getAttributes, ThemeUtils } from '../../../../../utils';
import { Sticky, StickyScreenPositions } from '../../../../templates/sticky';
import { Text, TextHtmlTags, TextVariants } from '../../../../atoms/text';
import { Button } from '../../../../atoms/button';
import { StockStatuses } from '../../common/stock-info/types';
import { Link, LinkFontSizes, LinkUnderlineOptions } from '../../../../atoms/link';
var MuiSCTAContainer = styled(Container, {
    name: 'MuiSCTAContainer',
    overridesResolver: function (wrapperProps, styles) { return [styles.root]; }
})({});
export var MuiSCTAText = styled(Text, {
    name: 'MuiSCTAText',
    overridesResolver: function (wrapperProps, styles) { return [styles.root]; }
})({});
export var MuiSCTALink = styled(Link, {
    name: 'MuiSCTALink',
    overridesResolver: function (wrapperProps, styles) { return [styles.root]; }
})({});
export var MuiSCTAButton = styled(Button, {
    name: 'MuiSCTAButton',
    overridesResolver: function (wrapperProps, styles) { return [styles.root]; }
})({});
var SCTA = function (_a) {
    var props = __rest(_a, []);
    var id = props.id, productName = props.productName, addToCartRef = props.addToCartRef, observableIDs = props.observableIDs, buttonLabel = props.buttonLabel, colorName = props.colorName, currentPrice = props.currentPrice, originalPrice = props.originalPrice, productStatus = props.productStatus, colorSelectorAnchor = props.colorSelectorAnchor, loadingButton = props.loadingButton, onButtonClick = props.onButtonClick, onColorNameClick = props.onColorNameClick, onStickyDisplayChange = props.onStickyDisplayChange, rest = __rest(props, ["id", "productName", "addToCartRef", "observableIDs", "buttonLabel", "colorName", "currentPrice", "originalPrice", "productStatus", "colorSelectorAnchor", "loadingButton", "onButtonClick", "onColorNameClick", "onStickyDisplayChange"]);
    var _b = useState({}), areRefInView = _b[0], setAreRefInView = _b[1];
    var _c = useState({}), inViewMap = _c[0], setInViewMap = _c[1];
    var _d = useState(false), isShown = _d[0], setIsShown = _d[1];
    var ADD_TO_CART_OBSERVABLE_ID = 'add-to-cart';
    useEffect(function () {
        var _a, _b;
        var elMap = (observableIDs === null || observableIDs === void 0 ? void 0 : observableIDs.map(function (obsId) {
            var _a;
            var el = document.getElementById(obsId);
            return el ? (_a = {}, _a[obsId] = el, _a) : {};
        }).filter(Boolean).reduce(function (accumulator, currentValue) {
            return Object.assign(accumulator, currentValue);
        }, {})) || {};
        if (addToCartRef === null || addToCartRef === void 0 ? void 0 : addToCartRef.current) {
            setAreRefInView(__assign(__assign({}, elMap), (_a = {}, _a[ADD_TO_CART_OBSERVABLE_ID] = addToCartRef === null || addToCartRef === void 0 ? void 0 : addToCartRef.current, _a)));
        }
        else {
            setAreRefInView(elMap);
        }
        var defaultInViewMap = (observableIDs === null || observableIDs === void 0 ? void 0 : observableIDs.map(function (obsId) {
            var _a;
            return (_a = {}, _a[obsId] = false, _a);
        }).filter(Boolean).reduce(function (accumulator, currentValue) {
            return Object.assign(accumulator, currentValue);
        }, {})) || {};
        if (addToCartRef === null || addToCartRef === void 0 ? void 0 : addToCartRef.current) {
            setInViewMap(__assign(__assign({}, defaultInViewMap), (_b = {}, _b[ADD_TO_CART_OBSERVABLE_ID] = true, _b)));
        }
        else {
            setInViewMap(defaultInViewMap);
        }
    }, []);
    /* istanbul ignore next */
    useEffect(function () {
        var intersectionObserver = new IntersectionObserver(function (entries) {
            var filteredEntries = entries.filter(function (entry) { return !!entry.rootBounds; });
            if (filteredEntries.length > 0) {
                var newInViewMap_1 = __assign({}, inViewMap);
                var hasChanged_1 = false;
                filteredEntries.forEach(function (entry) {
                    var _a, _b;
                    if (entry.target !== (addToCartRef === null || addToCartRef === void 0 ? void 0 : addToCartRef.current) &&
                        entry.isIntersecting !== inViewMap[(_a = entry === null || entry === void 0 ? void 0 : entry.target) === null || _a === void 0 ? void 0 : _a.id]) {
                        hasChanged_1 = true;
                        newInViewMap_1[(_b = entry === null || entry === void 0 ? void 0 : entry.target) === null || _b === void 0 ? void 0 : _b.id] = entry.isIntersecting;
                    }
                    if (entry.target === (addToCartRef === null || addToCartRef === void 0 ? void 0 : addToCartRef.current) &&
                        entry.isIntersecting !== inViewMap[ADD_TO_CART_OBSERVABLE_ID] &&
                        window.scrollY >= entry.boundingClientRect.top) {
                        hasChanged_1 = true;
                        newInViewMap_1[ADD_TO_CART_OBSERVABLE_ID] = entry.isIntersecting;
                    }
                });
                if (hasChanged_1) {
                    setInViewMap(newInViewMap_1);
                    var initializedInViewElementIds = Object.keys(newInViewMap_1).filter(function (elId) { return newInViewMap_1[elId] !== null; });
                    var noOneInView = !initializedInViewElementIds
                        .map(function (elId) { return newInViewMap_1[elId]; })
                        .some(Boolean);
                    var isNewlyShown = initializedInViewElementIds.length > 0 && noOneInView;
                    if (isShown !== isNewlyShown) {
                        setIsShown(isNewlyShown);
                    }
                }
            }
        });
        Object.values(areRefInView).forEach(function (el) {
            return intersectionObserver === null || intersectionObserver === void 0 ? void 0 : intersectionObserver.observe(el);
        });
        return function () {
            intersectionObserver === null || intersectionObserver === void 0 ? void 0 : intersectionObserver.disconnect();
        };
    }, [inViewMap, areRefInView]);
    useEffect(function () {
        onStickyDisplayChange === null || onStickyDisplayChange === void 0 ? void 0 : onStickyDisplayChange(isShown);
    }, [isShown]);
    var originalPriceText = currentPrice !== originalPrice ? originalPrice : null;
    var ctaConfig = {
        label: buttonLabel,
        onClick: onButtonClick,
        disable: productStatus === StockStatuses.OutOfStock,
        loading: loadingButton
    };
    var wrapperConfig = {
        backgroundTheme: ContainerBackgroundVariants.Main,
        padding: ThemeUtils.getResponsiveProp([
            { x: ContainerPaddings.Size_4, y: ContainerPaddings.Size_2 },
            { x: ContainerPaddings.Size_4, y: ContainerPaddings.Size_1 },
            { x: ContainerPaddings.Size_5 },
            { x: ContainerPaddings.Size_6 },
            { x: ContainerPaddings.Size_7 }
        ])
    };
    var innerWrapperConfig = {
        width: ContainerWidths.Boxed,
        display: ContainerDisplays.Flex,
        flexJustifyContent: ContainerFlexJustifyContents.SpaceBetween,
        flexAlignItems: ContainerFlexAlignItems.Center,
        flexGap: ContainerFlexGaps.Size_2
    };
    var leftContainerMobileConfig = {
        display: ContainerDisplays.Flex,
        flexDirection: ContainerFlexDirections.Column,
        flexGap: ContainerFlexGaps.Size_2,
        flexGrow: 0,
        flexShrink: 1
    };
    var innerContainerDesktopConfig = {
        display: ContainerDisplays.Flex,
        flexDirection: ContainerFlexDirections.Row,
        flexAlignItems: ContainerFlexAlignItems.Center,
        flexGap: ContainerFlexGaps.Size_3,
        flexShrink: 0
    };
    var leftContainerDesktopConfig = __assign(__assign({}, innerContainerDesktopConfig), { flexAlignItems: ContainerFlexAlignItems.Baseline, flexShrink: 1 });
    var bottomContainerMobileConfig = {
        display: ContainerDisplays.Flex,
        flexDirection: ContainerFlexDirections.Row,
        flexGap: ContainerFlexGaps.Size_2
    };
    var originalPriceTextConfig = {
        isHtml: true,
        content: originalPriceText || '',
        variant: TextVariants.Fs6,
        component: TextHtmlTags.Del
    };
    var currentPriceTextConfig = {
        isHtml: true,
        content: "<b>".concat(currentPrice, "</b>") || ''
    };
    var colorLinkConfig = {
        label: colorName || '',
        underline: LinkUnderlineOptions.Always,
        onClick: function () {
            var _a;
            onColorNameClick === null || onColorNameClick === void 0 ? void 0 : onColorNameClick();
            setInViewMap(__assign(__assign({}, inViewMap), (_a = {}, _a[ADD_TO_CART_OBSERVABLE_ID] = true, _a)));
        }
    };
    var colorLinkMobileConfig = __assign(__assign({}, colorLinkConfig), { fontSize: LinkFontSizes.Body3 });
    var colorLinkDesktopConfig = __assign(__assign({}, colorLinkConfig), { fontSize: LinkFontSizes.Body2 });
    var stickyConfig = __assign({ id: id, isShown: isShown }, getAttributes(rest));
    var mobileStickyConfig = __assign(__assign({}, stickyConfig), { screenPosition: StickyScreenPositions.Bottom });
    var desktopStickyConfig = __assign(__assign({}, stickyConfig), { screenPosition: StickyScreenPositions.Top });
    return (React.createElement(React.Fragment, null, ThemeUtils.getResponsiveRender([
        React.createElement(Sticky, __assign({}, mobileStickyConfig),
            React.createElement(Container, __assign({}, wrapperConfig),
                React.createElement(Container, __assign({}, innerWrapperConfig),
                    React.createElement(MuiSCTAContainer, __assign({}, leftContainerMobileConfig),
                        productName && (React.createElement(MuiSCTAText, { content: productName, variant: TextVariants.Body3 })),
                        (colorName || currentPrice) && (React.createElement(Container, __assign({}, bottomContainerMobileConfig),
                            colorName && React.createElement(MuiSCTALink, __assign({}, colorLinkMobileConfig)),
                            currentPrice && (React.createElement(Text, { content: currentPrice, variant: TextVariants.Body3 }))))),
                    buttonLabel && React.createElement(MuiSCTAButton, __assign({}, ctaConfig))))),
        null,
        React.createElement(Sticky, __assign({}, desktopStickyConfig),
            React.createElement(Container, __assign({}, wrapperConfig),
                React.createElement(Container, __assign({}, innerWrapperConfig),
                    React.createElement(MuiSCTAContainer, __assign({}, leftContainerDesktopConfig),
                        productName && (React.createElement(MuiSCTAText, { content: productName, variant: TextVariants.Fs5 })),
                        React.createElement(Container, null, colorName && React.createElement(MuiSCTALink, __assign({}, colorLinkDesktopConfig)))),
                    React.createElement(Container, __assign({}, innerContainerDesktopConfig),
                        originalPriceText && React.createElement(Text, __assign({}, originalPriceTextConfig)),
                        currentPrice && (React.createElement(Text, __assign({}, currentPriceTextConfig, { variant: TextVariants.Fs6 }))),
                        buttonLabel && React.createElement(Button, __assign({}, ctaConfig))))))
    ])));
};
export { SCTA as StickyCallToAction };
